/**
 * LP: Pre-lander — minimal routing-page controller.
 *
 * - Passes the inbound query string (UTMs, fbclid, gclid, …) through to each
 *   choice link so ad attribution survives the click-through.
 * - Pushes a `prelander_choice` dataLayer event on each click so pixel / GA
 *   can attribute the routing decision downstream.
 *
 * Re-runs on `shopify:section:load` so the theme editor's hot-reload picks
 * up newly added/edited choice blocks without a full page reload.
 */
(function () {
  'use strict';

  function initAll(root) {
    root = root || document;
    var prelanders = root.querySelectorAll('.lp-prelander');
    if (!prelanders.length) return;
    Array.prototype.forEach.call(prelanders, initPrelander);
  }

  function initPrelander(section) {
    if (section.__lpPrelanderInited) return;
    section.__lpPrelanderInited = true;

    // Parse the inbound query string once. We merge these into each choice
    // link via URLSearchParams (not string-concat) so we never produce a
    // malformed URL with two '?' separators or a duplicated key.
    //
    // Strip `view` before merging — it's the routing param used to render
    // the prelander itself, and each destination already declares its own
    // view (or chooses None) via its configured href. Letting `view` pass
    // through would make every "None"-configured card silently inherit the
    // prelander's view, breaking the dropdown's "No view" option.
    var inboundParams = new URLSearchParams(window.location.search || '');
    inboundParams.delete('view');
    var hasInbound = false;
    inboundParams.forEach(function () { hasInbound = true; });

    var choices = section.querySelectorAll('.lp-prelander__choice');

    Array.prototype.forEach.call(choices, function (link) {
      if (hasInbound) {
        var href = link.getAttribute('href') || '';
        if (href && href.indexOf('#') !== 0) {
          try {
            // `new URL` requires an absolute base — relative hrefs resolve
            // against the current document's origin.
            var url = new URL(href, window.location.origin);
            inboundParams.forEach(function (value, key) {
              // Don't override params the link already set (e.g. `view`).
              if (!url.searchParams.has(key)) {
                url.searchParams.set(key, value);
              }
            });
            // Re-emit as relative so the link stays origin-agnostic.
            link.setAttribute('href', url.pathname + url.search + url.hash);
          } catch (e) {
            // Malformed href — leave it alone rather than break the link.
          }
        }
      }

      // Fire a dataLayer event for downstream pixel/GA tracking.
      link.addEventListener('click', function () {
        var route = link.getAttribute('data-route') || '';
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'prelander_choice', route: route });
        } catch (e) { /* dataLayer push is best-effort — never block navigation */ }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();
